import React, { ReactNode } from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer"
import ScrollToTopButton from "../components/ScrollToTopButton";

type MainLayoutProps = {
    children: ReactNode;
    pageTitle: string;
};

export default function MainLayouts({ children, pageTitle }: MainLayoutProps) {
    return (
        <div className="min-h-screen flex flex-col relative container mx-auto">
            <Header />
            <main>{children}</main>
            <Footer />
            <ScrollToTopButton />
        </div>
    );
}
